module.exports = __webpack_public_path__ + "static/media/softsiteLogo3.c08f18b8.png";